// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BarL_TheComp__LfmQf"};